import { PeopleScreen } from '@/components/domain/members/PeopleScreen';

export default function PeopleNewScreen() {
  return <PeopleScreen listType="new" />;
}
